const HEX = Array.from({ length: 256 }, (_, byte) => byte.toString(16).padStart(2, "0"))

const toHex = (bytes: Uint8Array): string => Array.from(bytes, (byte) => HEX[byte]).join("")

export const uuidv7 = (at: number = Date.now()): string => {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)

  const ts = Math.floor(at)
  bytes[0] = Math.floor(ts / 2 ** 40) % 256
  bytes[1] = Math.floor(ts / 2 ** 32) % 256
  bytes[2] = Math.floor(ts / 2 ** 24) % 256
  bytes[3] = Math.floor(ts / 2 ** 16) % 256
  bytes[4] = Math.floor(ts / 2 ** 8) % 256
  bytes[5] = ts % 256

  bytes[6] = 0x70 | ((bytes[6] ?? 0) & 0x0f)
  bytes[8] = 0x80 | ((bytes[8] ?? 0) & 0x3f)

  const hex = toHex(bytes)
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export const UUIDV7_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/

export const uuidv7Timestamp = (id: string): number | null => {
  if (!UUIDV7_PATTERN.test(id)) return null

  const hex = id.replace(/-/g, "").slice(0, 12)
  return Number.parseInt(hex, 16)
}
